import {GoalVsRegistrationType} from '@/modules/business-plan/modules/models/enums/goalVsRegistrationType';
import {SaleTypeEnum} from '@/enums/sale-type.enum';

export enum OrderGroupEnum {
  channel = 1,
  family = 2
}

export interface getStoreValue {
  (storeValues: IGoalVsRegistrationData[], typeInformation: GoalVsRegistrationType, keyValue?: number, month?: number) : number,
}

export interface IData {
  id: number,
  name: string,
  orderGroupEnum: OrderGroupEnum,
  values: IData[],
  getValue: getStoreValue,
}

export interface IGoalVsRegistration {
  idProject: number;
  idStoreProject: number;
  idEconomicGroupProject: number;
  idStoreUnique: string;
  idStoreClient: string;
  nameStore: string;
  nameEconomicGroup: string;
  city: string;
  state: string;
  values: IGoalVsRegistrationData[]
}

export interface IGoalVsRegistrationData {
  idFamily: number;
  yearReference: number;
  monthReference: number;
  typeInformation: GoalVsRegistrationType;
  saleType: SaleTypeEnum;
  saleChannel: number;
  value: number;
}
